import styled from "styled-components";

export const Container = styled.main`
  overflow-x: hidden;
`;
